import { Component, Inject, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../auth/auth.service';
import { AuthUserModel } from '../../model/auth_user.model';
import { TrainerApproveAllModel } from '../../model/trainer_approve_all.model';
import { UserModel } from '../../model/user.model';
import { MedicalProcedureService } from '../../providers/medical_procedure.service';
import { TraineeMedicalProcedureCaseModel } from '../../model/trainee_medical_procedure_case.model';

@Component({
	selector: 'app-trainee-rotations-approveall-dialog',
	templateUrl: './trainee-procedure-case-approveall-dialog.component.html',
	styleUrls: [ './trainee-procedure-case-approveall-dialog.component.css' ]
})
export class TraineeProceduresApproveAllDialogComponent implements OnInit {
	item: TrainerApproveAllModel;
	mAuthService: AuthService;
	errorMessage: string = '';
	isLoading: boolean = true;
	durationInSeconds = 1;
	mUserFacultyId: string;
	mUserId: string;
	mUser: UserModel;
	authUser: AuthUserModel = null;
	//  authUser:AuthUserModel
	mItems: TraineeMedicalProcedureCaseModel[];

	constructor(
		private fb: FormBuilder,
		private location: Location,
		private mApiService: MedicalProcedureService,
		private _snackBar: MatSnackBar,
		private dialogRef: MatDialogRef<TraineeProceduresApproveAllDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.item = new TrainerApproveAllModel();
		// this.authUser = new AuthUserModel()
	}

	ngOnInit(): void {
		// console.log(this.item);
		this.item = this.data;
		console.log(this.data);
	}

	getItemsList(supervisorId: string, userId: string) {
		this.mItems = [];
		this.isLoading = true;

		this.mApiService.getTrainerTraineeProcedureCases(supervisorId, userId).subscribe(
			(p) => {
				(this.mItems = p), console.log(p);
			},
			(e) => (this.errorMessage = e),
			() => (this.isLoading = false)
		);
	}

	//   getItemsList()
	// {
	//      this.mItems=[];
	//      this.isLoading=true;

	//          this.mApiService.getTraineeMedicalProcedureCases(this.mTraineeMedicalProcedure.FacultyMedicalProcedureId,this.mTraineeMedicalProcedure.StudentId)
	//          .subscribe(
	//            p=>{

	//               this.setItems(p);
	//                console.log(p);

	//         },
	//            e => this.errorMessage = e,
	//            ()=>this.isLoading=false
	//          )

	// }

	close() {
		this.dialogRef.close();
	}
	approveAll() {
		//  let authUser=this.mAuthService.authUser;
		let authUser = this.data.SupervisorId;
		let approveData = new TrainerApproveAllModel();
		approveData.StudentId = this.data.StudentId;
		approveData.SupervisorId = authUser;
		approveData.Action = 'APPROVED';
		approveData.Remark = '';
		// console.log(JSON.stringify(approveData));
		console.log(approveData.SupervisorId);
		console.log(approveData.StudentId);

		this.mApiService.approveAllTrainerTraineePendingProcedures(approveData).subscribe(
			(p) => {
				this.dialogRef.close();

				if (p) {
					if (p.success == 0) this.getItemsList(approveData.SupervisorId, approveData.StudentId);
					// this.getItemsList(authUser.userId, this.mUser.Id);
				}
			},
			(e) => (this.errorMessage = e),
			() => (this.isLoading = false)
		);
		this.location.back();
	}
}
